<template>
  <div class="attendance-details">
    <van-nav-bar :title="selectedEmployee.name + '的打卡详情'" left-text="返回" @click-left="goBack" />

    <van-calendar
        v-model="calendarDate"
        :min-date="minDate"
        :max-date="maxDate"
        @click="showAttendanceForDate"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedEmployee: {}, // 这里是从路由参数中获取的员工信息
      calendarDate: new Date(),
      minDate: new Date('2023-01-01'),
      maxDate: new Date('2023-12-31'),
      attendanceData: [
        { date: '2023-11-01', status: 'normal' },
        { date: '2023-11-02', status: 'late' },
        // Add more attendance data as needed
      ],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    showAttendanceForDate(date) {
      const formattedDate = this.formatDate(date);
      const attendance = this.attendanceData.find(item => item.date === formattedDate);
      if (attendance) {
        // 在这里展示该日期的打卡详情或者采取其他操作
        console.log('Attendance for', formattedDate, 'is:', attendance.status);
      } else {
        console.log('No attendance data found for', formattedDate);
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, '0');
      const day = `${date.getDate()}`.padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped>
.attendance-details {
  padding: 20px;
}
</style>
